// extracted by mini-css-extract-plugin
export var completionBody = "_k3-2";
export var completionCard = "_k3-0";
export var completionFooter = "_k3-3";
export var completionTitle = "_k3-1";